import React from 'react';
import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import { format, parseISO } from 'date-fns';

const styles = StyleSheet.create({
  page: {
    padding: 40,
    fontSize: 11,
    fontFamily: "Helvetica",
    backgroundColor: "#F9F9F9",
    color: "#263238",
  },
  headerContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 25,
  },
  logo: {
    width: 60,
    height: 60,
  },
  title: {
    fontSize: 20,
    textAlign: "right",
    color: "#1B5E20",
    fontWeight: "bold",
    textTransform: "uppercase",
  },
  section: {
    padding: 12,
    border: "1pt solid #B0BEC5",
    borderRadius: 5,
    marginBottom: 18,
    backgroundColor: "#FFFFFF",
  },
  sectionTitle: {
    fontSize: 13,
    marginBottom: 10,
    borderBottom: "1pt solid #90A4AE",
    paddingBottom: 4,
    fontWeight: "bold",
    color: "#37474F",
  },
  field: {
    marginBottom: 6,
  },
  label: {
    fontWeight: "bold",
    color: "#455A64",
  },
  signatureImage: {
    marginTop: 10,
    height: 80,
    border: "1pt dashed #B0BEC5",
  },
  footer: {
    position: "absolute",
    bottom: 30,
    fontSize: 9,
    textAlign: "center",
    width: "100%",
    color: "#90A4AE",
  },
});

const Field = ({ label, value }) => (
  <View style={styles.field}>
    <Text>
      <Text style={styles.label}>{label}: </Text>
      <Text>{value || 'N/A'}</Text>
    </Text>
  </View>
);

const formatDate = (dateStr) =>
  dateStr ? format(parseISO(dateStr), 'MM/dd/yyyy') : 'N/A';

const PayrollDeductionPDF = ({ formData }) => {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Header */}
        <View style={styles.headerContainer}>
          <Image src="/rciLogo.png" style={styles.logo} />
          <Text style={styles.title}>Payroll Deduction</Text>
        </View>

        {/* Employee Info */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Employee Information</Text>
          <Field label="Employee Name" value={formData.employeeName} />
          <Field label="Pay ID" value={formData.payId} />
          <Field label="Supervisor" value={formData.supervisor} />
          <Field label="Project" value={formData.project} />
          <Field label="Date" value={formatDate(formData.date)} />
        </View>

        {/* Deduction Summary */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Deduction Items</Text>
          <Field label="Total Deduction Amount ($)" value={formData.totalAmount} />
          {Object.entries(formData.deductions || {}).map(([key, item]) =>
            item?.enabled ? (
              <Field
                key={key}
                label={key.charAt(0).toUpperCase() + key.slice(1)}
                value={item.value}
              />
            ) : null
          )}
        </View>

        {/* Frequency */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Deduction Frequency</Text>
          <Field label="One Time Only" value={formData.frequency.oneTime ? "Yes" : "No"} />
          <Field label="Weekly" value={formData.frequency.weekly ? "Yes" : "No"} />
          <Field label="Custom Weekly Amount" value={formData.frequency.customAmount} />
          <Field label="Number of Weeks" value={formData.frequency.customWeeks} />
          <Field label="Other" value={formData.frequency.other} />
        </View>

        {/* Signature */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Employee Signature</Text>
          {formData.signature ? (
            <Image style={styles.signatureImage} src={formData.signature} />
          ) : (
            <Text>No signature provided</Text>
          )}
        </View>

        <Text style={styles.footer}>Confidential — For Internal Use Only</Text>
      </Page>
    </Document>
  );
};

export default PayrollDeductionPDF;
